import { render, staticRenderFns } from "./UnauthorizedAgeConfirm.vue?vue&type=template&id=39bdbbef&scoped=true&"
import script from "./UnauthorizedAgeConfirm.vue?vue&type=script&lang=ts&"
export * from "./UnauthorizedAgeConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./UnauthorizedAgeConfirm.vue?vue&type=style&index=0&id=39bdbbef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bdbbef",
  null
  
)

export default component.exports